/** Utilidades para compartir documentos (presupuestos) */
import { formatCurrency } from './formatters';

export interface BudgetShareInput {
  number: string;
  companyName: string;
  clientName?: string;
  total: number;
}

export function buildBudgetShareText({ number, companyName, clientName, total }: BudgetShareInput): string {
  const lines = [
    `Presupuesto ${number} · ${companyName}`,
    clientName ? `Cliente: ${clientName}` : '',
    `Total: ${formatCurrency(total)}`,
  ].filter(Boolean);
  return lines.join('\n');
}

export function absoluteAppUrl(path: string): string {
  const base = import.meta.env.BASE_URL || '/';
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return new URL(`${base.replace(/\/$/, '')}${normalized}`, window.location.origin).href;
}

export function whatsappShareUrl(text: string): string {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function mailtoShareUrl(subject: string, body: string): string {
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* fallback abajo */
  }
  try {
    const el = document.createElement('textarea');
    el.value = value;
    el.style.position = 'fixed';
    el.style.opacity = '0';
    document.body.appendChild(el);
    el.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(el);
    return ok;
  } catch {
    return false;
  }
}

export function canUseSystemShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function systemShare(data: { title: string; text: string; url?: string }): Promise<boolean> {
  if (!canUseSystemShare()) return false;
  try {
    await navigator.share(data);
    return true;
  } catch {
    return false;
  }
}
